import script from "./UserIntegral.vue?vue&type=script&setup=true&lang=js"
export * from "./UserIntegral.vue?vue&type=script&setup=true&lang=js"

import "./UserIntegral.vue?vue&type=style&index=0&id=7b30c11a&lang=css"

const __exports__ = script;

export default __exports__